import { DatasetUpdatesTypes } from "@focus/interfaces/lib/program/DatasetUpdate";
import { Observable } from "rxjs/Observable";
import { StompActionskeys } from "../stomp-broker";
import { whenConnected } from "../helpers/subscription";
import { isSamePanelConfig, isSamePathSubscription } from "../helpers/utils";
var PanelUpdateActions;
(function (PanelUpdateActions) {
    PanelUpdateActions["UPDATE_ON_CHANGE"] = "FILE_SUB/UPDATE_ON_CHANGE";
    PanelUpdateActions["NOUPDATE_ON_CHANGE"] = "FILE_SUB/NOUPDATE_ON_CHANGE";
})(PanelUpdateActions || (PanelUpdateActions = {}));
export const subscribeToFileUpdate = (config) => ({
    payload: config,
    type: PanelUpdateActions.UPDATE_ON_CHANGE,
});
export const unSubscribeToFileUpdate = (config) => ({
    payload: config,
    type: PanelUpdateActions.NOUPDATE_ON_CHANGE,
});
export const createListenToDataFileChangesEpic = (fetchPanel) => (actions$, _, { stomp }) => whenConnected(actions$, PanelUpdateActions.UPDATE_ON_CHANGE).mergeMap(([_value, action]) => stomp
    .subscribe(`/user/topic/focus/dataset`)
    .filter((res) => res.type === DatasetUpdatesTypes.DATASET_UPDATED)
    .filter((subsAction) => isSamePathSubscription(action.payload.subscriptionPaths.data, subsAction.payload.id))
    .mergeMap(() => Observable.of(fetchPanel(action.payload)))
    .catch(() => Observable.empty())
    .takeUntil(Observable.merge(actions$
    .ofType(PanelUpdateActions.NOUPDATE_ON_CHANGE)
    .filter((subsAction) => isSamePanelConfig(action.payload, subsAction.payload)), actions$.ofType(StompActionskeys.DISCONNECTED).take(1))));
//# sourceMappingURL=fileUpdate.js.map